import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-dropdown-menu',
    templateUrl: './dropdown-menu.component.html',
    styleUrls: ['./dropdown-menu.component.scss'],
    standalone: false
})
export class DropdownMenuComponent {

  @Input() icon: string;
  @Input() text: string;
  @Input() stylingClass: string;

  isVisible = false;
}
